<template>
  <div class="ws-modal">
    <form class="ws-modal__form" @submit.prevent="submit">
      <header class="ws-modal__header">
        <div class="columns">
          <div class="column is-8">
            <h2 class="has-text-weight-bold is-size-1">
              <span v-text="$t('Управление кураторами')"></span>
            </h2>
          </div>
        </div>
      </header>
      <div class="ws-modal__content">
        <div class="columns is-multiline">
          <div class="column is-12">
            <ws-search-users @input-users="updateUsersList" :placeholder="$t('Введите имя')" />
          </div>
          <div class="column is-12">
            <ws-list-view class="ws-participants__list"
                          :data="newCurators"
                          :header="false"
                          :detailed="false">
              <template slot-scope="props">
                <ws-list-view-item-column>
                  <div class="ws-participants__item" v-if="props.row.user_info">
                    <figure class="ws-participants__item-avatar image is-96x96">
                      <ws-avatar :id="props.row.guid"
                                 :name="`${ props.row.user_info.first.display } ${props.row.user_info.last.display}`"
                                 sizeType="Small"
                                 :size="96" />
                    </figure>
                    <div class="ws-participants__item-name">
                        {{ props.row.user_info.first.display }} {{ props.row.user_info.last.display }} {{ props.row.user_info.middle.display }}
                    </div>
                    <div class="ws-participants__item-type has-text-right-desktop">
                    </div>
                    <div class="ws-participants__item-info">
                      {{ props.row.user_info.login }}
                    </div>
                    <div class="ws-participants__item-status"></div>
                    <div class="ws-participants__item-email">
                      {{ props.row.user_info.email }}
                    </div>
                    <div class="ws-participants__item-action">
                      <button
                        type="button"
                        class="ws-button button is-danger is-small is-fullwidth"
                        @click="removeUserFromList(props.row.guid)"
                        v-text="$t('Убрать')"></button>
                    </div>
                  </div>
                </ws-list-view-item-column>
              </template>
              <template slot="skeleton">
                <ws-list-view-skeleton-item :height="'107px'" :boxCount="1" :boxHeights="['105px']" />
                <ws-list-view-skeleton-item :height="'107px'" :boxCount="1" :boxHeights="['105px']" />
              </template>
            </ws-list-view>
          </div>
        </div>
      </div>
      <footer class="ws-modal__footer">
        <div class="columns">
          <div class="column is-8"></div>
          <div class="column is-4 is-vcentered">
            <div class="has-text-right-desktop">
              <button type="submit"
                      class="ws-button button is-large is-primary is-fullwidth"
                      :disabled="newCurators.length === 0">
                <span class="is-size-4 has-text-weight-bold" v-text="$t('Сохранить')"></span>
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
    <aside class="ws-modal__sidebar">
      <button class="ws-button button is-text"
              @click.prevent="close">
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
    <b-loading :is-full-page="false" :active.sync="isPending" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'WsCuratorsManagement',
  props: {
    org: {
      type: Object
    },
    curators: {
      type: Array
    }
  },
  data () {
    return {
      newOrg: {},
      newCurators: [],
      isPending: false
    }
  },
  watch: {
    org: {
      deep: true,
      immediate: true,
      handler (org) {
        this.newOrg = org
      }
    },
    curators: {
      deep: true,
      immediate: true,
      handler (curators) {
        this.newCurators = curators
      }
    }
  },
  methods: {
    ...mapActions('refbook/curators', ['update', 'remove']),
    updateUsersList (curators) {
      this.newCurators = [...this.newCurators, ...curators.map(curator => {
        return {
          guid: curator.guid,
          user_info: curator
        }
      })]
    },
    async removeUserFromList (guid) {
      try {
        this.isPending = true
        await this.remove([null, { [this.newOrg.guid]: [guid] }])
        if (this.newCurators && this.newCurators.length) {
          this.newCurators = [...this.newCurators.filter(curator => curator.guid !== guid)]
          this.$emit('updateCurators', this.newCurators)
        }
      } catch (e) {
        // console.log(e)
      }
      this.isPending = false
    },
    async submit () {
      this.isPending = true
      const curators = await this.update([null, { [this.newOrg.guid]: this.newCurators.map(user => user.guid) }])
      this.$emit('updateCurators', curators[this.newOrg.guid])
      this.isPending = false
      this.$parent.close()
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>
<style scoped>
  .ws-participants__list {
    height: auto;
    max-height: auto;
  }
</style>
